import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
  standalone: true,
  pure:false
})
export class TruncatePipe implements PipeTransform {
  transform(value: string | null | undefined, limit: number): string {
  if (!value) return '';
  return value.length <= limit ? value : value.slice(0, limit) + '...';
}
}